import {
  GET_SUBSCRIPTIONS,
  GET_ACTIVE_SUBSCRIPTIONS,
  GET_SUBSCRIBERS,
  GET_PAYMENT_CONFIRMATION,
  CANCEL_SUBSCRIPTION,
  SUBSCRIPTION_FAIL,
  SUBSCRIBE_FAIL,
  CLEAR_SUBSCRIPTIONS,
  CLEAR_SUBSCRIBERS,
  GET_MENTORS,
  GET_GIFTED_USERS,
} from "../actions/types";

const initialState = {
  mentors: [],
  users: [],
  subscriptions: [],
  activesubscriptions: [],
  subscription: {},
  canceledsubscription: {},
  subscribers: [],
  subscriber: {},
  payment: {},
  loading: true,
  error: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_MENTORS:
      return {
        ...state,
        mentors: payload,
        loading: false,
      };
    case GET_GIFTED_USERS:
      return {
        ...state,
        users: payload,
        loading: false,
      };
    case GET_SUBSCRIPTIONS:
      return {
        ...state,
        subscriptions: payload,
        loading: false,
      };
    case GET_ACTIVE_SUBSCRIPTIONS:
      return {
        ...state,
        activesubscriptions: payload,
        loading: false,
      };
    case GET_SUBSCRIBERS:
      return {
        ...state,
        subscribers: payload,
        loading: false,
      };
    case CANCEL_SUBSCRIPTION:
      return {
        ...state,
        canceledsubscription: payload,
        loading: false,
      };
    case GET_PAYMENT_CONFIRMATION:
      return {
        ...state,
        payment: payload,
        loading: false,
      };
    case SUBSCRIPTION_FAIL:
    case SUBSCRIBE_FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case CLEAR_SUBSCRIBERS:
    case CLEAR_SUBSCRIPTIONS:
      return {
        ...state,
        subscription: null,
        mentors: [],
        activesubscriptions: [],
        subscriber: null,
        subscribers: [],
        loading: false,
      };
    default:
      return state;
  }
}
